import React from "react";
import { useHistory } from "react-router-dom";
import { Plus } from "lucide-react";
import styles from "./FeedStoriesBar.module.css";
import { DUMMY_STORIES } from "./dummyFeedData";
import { useAppSelector } from "../../../redux/typedHooks";
import { UserInterface } from "../../../types/user";

export default function FeedStoriesBar() {
  const history = useHistory();
  const currentUser = useAppSelector<UserInterface | null>((state) => state.user.currentUser);

  const myAvatar =
    currentUser?.profileImg ||
    "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80";

  return (
    <div className={styles.storiesContainer}>
      {/* My Story / Add story item */}
      <button
        className={styles.storyItem}
        onClick={() => history.push("/create-post")}
      >
        <div className={`${styles.avatarRing} ${styles.avatarRingSeen}`}>
          <img src={myAvatar} alt="My story" className={styles.avatarImg} />
          <span className={styles.addStoryBadge}>
            <Plus size={12} strokeWidth={3} />
          </span>
        </div>
        <span className={styles.creatorName}>Your Story</span>
      </button>

      {/* Creator Stories */}
      {DUMMY_STORIES.map((story) => {
        return (
          <button
            key={story.id}
            className={styles.storyItem}
            onClick={() => history.push(`/${story.creator.username}`)}
          >
            <div
              className={`${styles.avatarRing} ${
                !story.hasUnseenStory ? styles.avatarRingSeen : ""
              }`}
            >
              <img
                src={story.creator.avatar}
                alt={story.creator.name}
                className={styles.avatarImg}
              />
              {story.isLive && <span className={styles.liveBadge}>LIVE</span>}
            </div>
            <span className={styles.creatorName}>{story.creator.name}</span>
          </button>
        );
      })}
    </div>
  );
}
